import React from "react";
import "./ConstruccionCivil.css"; // reutiliza los estilos modernos
import mecatronicaImg from "../assets/images/mecatronica.jpg";
import pdfMalla from "../assets/docs/mecatronica.pdf";
import { FaCar, FaDownload, FaTools } from "react-icons/fa";

const MecatronicaAutomotriz = () => {
  return (
    <section className="carrera-detalle">
      {/* Banner superior */}
      <div
        className="carrera-hero-modern"
        style={{ backgroundImage: `url(${mecatronicaImg})` }}
      >
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Mecatrónica Automotriz</h1>
          <p>
            Formamos profesionales técnicos especializados en mantenimiento,
            diagnóstico y automatización automotriz moderna.
          </p>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
          {/*  Información principal */}
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaCar className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN MECATRÓNICA AUTOMOTRIZ
              </h3>

              <h5 className="fw-bold text-primary mt-4">
                DESCRIPCIÓN DEL PERFIL DE EGRESO
              </h5>
              <p>
                El profesional técnico en Mecatrónica Automotriz del Instituto
                de Educación Superior Tecnológico Público “Gilda Liliana
                Ballivián Rosado” tiene competencias para realizar el
                mantenimiento programado, reparación y diagnóstico de sistemas
                automotrices convencionales y electrónicos.
              </p>
              <p>
                Está capacitado para intervenir en sistemas de suspensión,
                dirección, frenos, sistemas eléctricos, de transmisión y
                motores, tanto en vehículos convencionales como con asistencia
                electrónica, garantizando la calidad y seguridad del servicio.
              </p>
              <p>
                Además, puede realizar conversiones de sistemas de combustible y
                aplicar metodologías modernas de diagnóstico electrónico, bajo
                las normativas técnicas y ambientales vigentes.
              </p>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIA GENERAL</h5>
              <p>
                Planificar, organizar y supervisar el mantenimiento integral de
                unidades automotrices, aplicando normas de seguridad industrial,
                control de calidad y protección del medio ambiente.
              </p>

              <h5 className="fw-bold text-primary mt-4">
                CAMPOS DE ACCIÓN EN LOS QUE SE INSERTAN LOS EGRESADOS
              </h5>
              <p>
                El profesional técnico en Mecatrónica Automotriz puede
                desempeñarse en talleres automotrices, concesionarios,
                empresas industriales, instituciones públicas y privadas, o
                crear su propio negocio.
              </p>

              <h5 className="fw-bold text-primary mt-4">PUESTOS DE TRABAJO</h5>
              <ul>
                <li>Jefe de taller automotriz</li>
                <li>Especialista en instalaciones eléctricas y electrónicas</li>
                <li>Reparación de motores y sistemas de transmisión</li>
                <li>Supervisor de mantenimiento automotriz</li>
                <li>Rectificador de motores</li>
                <li>Operador de máquinas-herramientas</li>
                <li>Especialista en afinamiento electrónico (gasolina o diésel)</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">
                SALIDA HACIA OTROS ESTUDIOS
              </h5>
              <ul>
                <li>Ingeniería Mecatrónica</li>
                <li>Ingeniería Mecánica</li>
                <li>Ingeniería Industrial</li>
                <li>Ingeniería en Mantenimiento</li>
                <li>Ingeniería Metalúrgica</li>
                <li>Educación Técnica</li>
              </ul>
            </div>
          </div>

          {/* Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img
                src={mecatronicaImg}
                alt="Mecatrónica Automotriz"
                className="img-fluid rounded-3 mb-3"
              />
              <a
                href={pdfMalla}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-download w-100"
              >
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024
                (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">
                  Seis semestres equivalentes a tres años académicos.
                </p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno - 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno - 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MecatronicaAutomotriz;
